import React from "react";
import styles from "./style-contest.module.css";

import NumberFormat from "react-number-format";

import { Button, ButtonGroup } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";

import WaterfallMatrix from "components/ValueMatrix/WaterfallMatrix";
import Waterfall from "components/Waterfall/Waterfall";

export default class ModelTileContest extends React.PureComponent {
  state = {
    opacity: 0,
    showFeatures: false
  };

  componentDidMount() {
    setTimeout(() => this.setState({ opacity: 1.0 }), 150);
  }

  attemptSelect(field, values) {
    const dashboard =
      window.tableau &&
      window.tableau.extensions &&
      window.tableau.extensions.dashboardContent &&
      window.tableau.extensions.dashboardContent.dashboard
        ? tableau.extensions.dashboardContent.dashboard
        : undefined;

    if (dashboard !== undefined) {
      for (worksheet of dashboard.worksheets) {
        worksheet.selectMarksByValueAsync(
          [
            {
              fieldName: field,
              value: values
            }
          ],
          "select-replace"
        );
      }
    }
  }

  renderInfo(label, num, pct) {
    const { isContinuous } = this.props;

    return (
      <div className={styles.modelInfo}>
        <div className={styles.infoNum}>{num}</div>
        <div className={styles.infoPct} style={isContinuous ? { width: "200px" } : {}}>
          {pct}
        </div>
      </div>
    );
  }

  render() {
    const {
      model,
      hideCosts,
      processLimit,
      isNoClick,
      truePositiveLabel,
      trueNegativeLabel,
      falsePositiveLabel,
      falseNegativeLabel,
      isQuickRun,
      isTwoMinuteRun,
      scoreCount,
      hasLeft,
      hasRight,
      onClick,
      isFeatured,
      updateFeatureSelection,
      updateModelIndex,
      netImpactLabel,
      updateDeploy,
      showFeatures
    } = this.props;

    const { opacity } = this.state;

    const maxIteration = model.maxIteration;
    const metrics = model.metrics;
    const isContinuous = metrics && Object.keys(metrics).length > 0;

    return (
      <div
        className={styles.modelContest}
        style={{
          opacity: opacity
        }}
      >
        <div className={styles.modelLabel}>
          {hasLeft && (
            <span className={styles.arrow} style={{ left: "-8px" }} onClick={() => updateModelIndex(-1)}>
              <FontAwesomeIcon icon={faChevronLeft} />
            </span>
          )}
          {hasRight && (
            <span className={styles.arrow} style={{ right: "-8px" }} onClick={() => updateModelIndex(1)}>
              <FontAwesomeIcon icon={faChevronRight} />
            </span>
          )}
          <div className={styles.mLabel} title={model.label}>
            <span>{model.label}</span>
          </div>
        </div>
        {showFeatures !== true && (
          <div className={styles.modelGraph}>
            <Waterfall
              bars={model.bars}
              totalLabel={isContinuous ? "Total Relative Cost" : netImpactLabel}
              showTotalVal={isQuickRun && !isContinuous ? false : true}
              hideTotal={isQuickRun && !isContinuous ? true : false}
              largest={isQuickRun ? undefined : model.largest}
            />
          </div>
        )}
        {metrics.overImpact === undefined &&
          !isTwoMinuteRun &&
          showFeatures !== true &&
          maxIteration.improvement !== undefined &&
          !isQuickRun && (
            <div className={styles.infoHolder}>
              <div className={styles.roiImprovement}>
                <NumberFormat
                  value={Math.round(maxIteration.improvement)}
                  displayType={"text"}
                  thousandSeparator={true}
                />
              </div>
            </div>
          )}
        {showFeatures !== true && (
          <div className={styles.modelHolder}>
            {maxIteration.truePositive !== undefined &&
              isQuickRun !== true &&
              this.renderInfo(
                "Processed",
                Math.round(maxIteration.truePositive + maxIteration.falsePositive),
                (((maxIteration.truePositive + maxIteration.falsePositive) / processLimit) * 100).toFixed(1) + "%"
              )}
            {maxIteration.truePositive !== undefined &&
              this.renderInfo(
                truePositiveLabel,
                Math.round(maxIteration.truePositive),
                maxIteration.truePositive + maxIteration.falsePositive === 0
                  ? 0
                  : (
                      (maxIteration.truePositive / (maxIteration.truePositive + maxIteration.falsePositive)) *
                      100
                    ).toFixed(1) + "%"
              )}
            {maxIteration.truePositive !== undefined &&
              this.renderInfo("Accuracy", undefined, (maxIteration.accuracy * 100).toFixed(1) + "%")}
            {maxIteration.precision !== undefined &&
              model.id !== "Current State" &&
              this.renderInfo("Precision", undefined, (maxIteration.precision * 100).toFixed(1) + "%")}
            {maxIteration.recall !== undefined &&
              model.id !== "Current State" &&
              this.renderInfo("Recall", undefined, (maxIteration.recall * 100).toFixed(1) + "%")}
            {model &&
              model.metadata &&
              model.metadata.log_loss !== undefined &&
              model.id !== "Current State" &&
              this.renderInfo("Log Loss", undefined, model.metadata.log_loss.toFixed(4))}
            {metrics.mean_absolute_error !== undefined &&
              this.renderInfo("Mean Absolute Error", undefined, metrics.mean_absolute_error.toFixed(2))}
            {metrics.overImpact !== undefined &&
              this.renderInfo(
                "Sum of Overestimates",
                undefined,
                <NumberFormat value={metrics.overImpact.toFixed(2)} displayType={"text"} thousandSeparator={true} />
              )}
            {metrics.underImpact !== undefined &&
              this.renderInfo(
                "Sum of Underestimates",
                undefined,
                <NumberFormat value={metrics.underImpact.toFixed(2)} displayType={"text"} thousandSeparator={true} />
              )}
          </div>
        )}
      </div>
    );
  }
}
